import { CTACard } from './CTACard'

type InitialRdCTACardProps = {
  clickHandler: () => void
}

export const InitialRdCTACard = ({ clickHandler }: InitialRdCTACardProps) => {
  const imageSrc = '/images/Allara_Illustration_Nutrition-10.png'
  const buttonText = 'Book a nutrition visit'
  return (
    <CTACard
      imageSrc={imageSrc}
      clickHandler={clickHandler}
      buttonText={buttonText}
    />
  )
}
